import * as React from 'react';
import '../../Styles/layout/footer.sass';
import {FC} from "react";

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        sp?: { loadPrivacyManagerModal?: (value: number) => void };
    }
}

export const Footer: FC = () => {
    const links = [{ name: "Privacy Manager", href: "#cmp", onClick: () => window.sp?.loadPrivacyManagerModal?.(883462)}, { name: "Datenschutz", href: "/datenschutzerklaerung" }, { name: "AGB", href: "/agb" }, { name: "Impressum", href: "/impressum" }];

    return (<div className="footer">
        <span className="footer__copyright">&copy; Cornelsen Verlag GmbH, {new Date().getFullYear()}</span>
        <nav className="footer__menu">
            {links.map((link, index) => (<a key={index} href={link.href} onClick={link.onClick} className="footer-menu-link">{link.name}</a>))}
        </nav>
    </div>);
};
